import {useModal} from "@ebay/nice-modal-react";
import {Dialog as MuiDialog} from "@mui/material";
import React, {ReactNode} from "react";
import {Button} from "./Button";
import {CloseDialogButton} from "./CloseDialogButton";
import {Container} from "./Container";
import {Text} from "./Text";

interface DialogProps {
  title: string;
  onClick?: () => void;
  onClose?: () => void;
  buttonText?: string;
  disabled?: boolean;
  autoClose?: boolean;
  width?: string;
  minWidth?: string;
  padding?: string;
  children?: ReactNode;
}

export const Dialog = ({
  title,
  buttonText = "Confirm",
  onClick,
  onClose,
  disabled = false,
  width,
  minWidth,
  padding,
  autoClose = true,
  children,
}: DialogProps) => {
  const modal = useModal();
  const onClickModal = async () => {
    onClick?.();
    if (autoClose) {
      modal.resolve(true);
      modal.hide();
    }
  };

  return (
    <MuiDialog
      open={modal.visible}
      TransitionProps={{
        onExited: () => {
          onClose?.();
          modal.remove();
        },
      }}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "16px",
          padding: padding || "44px",
          minWidth,
        },
      }}
    >
      <CloseDialogButton onClose={modal.hide} />
      <Container sx={{gap: "24px", width: width || "300px"}}>
        <Container fullWidth sx={{alignItems: "start"}}>
          <Text variant={"interDisplay600"} size={24}>
            {title}
          </Text>
        </Container>
        {children}
        <Container fullWidth sx={{gap: "8px"}}>
          <Button onClick={onClickModal} disabled={disabled} fullWidth>
            {buttonText}
          </Button>
        </Container>
      </Container>
    </MuiDialog>
  );
};
